<div [formGroup]="inputFormGroup">
	<div *ngFor="let inp of inputText; let i = index;"
		class="{{className}}"
		>
		<div class="d-flex align-items-center">
			<input [type]="inputType" 
				class="form-control input-text-item" 
				[formControlName]="i"
				[ngClass]="{'invalid': (inputFormGroup.controls[i].invalid && attemptedSubmit)}"
				>
			
			<app-btn-common text="Remove" 
				class="ml-3" 
				className="btn-link text-danger no-break" 
				icon="trash-alt"
				(click)="removeTextInput(i)"
				></app-btn-common>
		</div>

		<div class="label-error mt-2" *ngIf="inputFormGroup.controls[i].hasError('email') && attemptedSubmit">Please enter valid email.</div>
		<!-- <div class="bred text-small mt-2" *ngIf="inputFormGroup.controls[i].errors">errors: {{inputFormGroup.controls[i].errors | json}}</div> -->

	</div>
</div>